import styled from 'styled-components';

export const InputWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: 30px 0;
  border-bottom: 2px solid #d8dfff;

  & > * {
    margin: 0.5em 0.75em;
  }

  label {
    font-size: 1.6rem;
  }
`;

export const Header = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;

  div {
    display: flex;
    align-items: center;
  }
`;

export const TabWrapper = styled.div`
  padding: 0 30px;
`;
